import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import {getContractListRequest} from "../../utils/apis/account";
import {useDispatch, useSelector} from "react-redux";
import ReactTable from "../../components/ReactTable/ReactTable";
import moment from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {ToastContainer, toast} from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import {Box, IconButton, Menu, MenuItem, Tooltip} from "@mui/material";
import {digiSigner, manualDigiSign} from "../../utils/apis/user";
import {returnErrors} from "../../store/reducers/error";
import {useNavigate} from "react-router-dom";
import {getAccountList, setActiveAccount} from "../../store/reducers/accountSlice";
import LoaderOverlay from "../../reusableComponents/Loader";
import ConfirmationModal from "../../reusableComponents/CondirmalModal/ConfirmationModal";
import {returnMessages} from "../../store/reducers/message";
export const Contactlits = () => {
  const idToken = useSelector((state) => state.auth.idToken);
  const [contactList, setContactList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const fetchContactList = async () => {
    setIsLoading(true);
    const response = await getContractListRequest(idToken, selectedBrand);
    setContactList(response.results);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchContactList();
  }, [idToken]);
  const truncateString = (inputString, maxLength) => {
    const formattedString = inputString.toString();
    if (formattedString.length > maxLength) {
      return inputString.toString().substring(0, maxLength) + "...";
    }
    return inputString;
  };

  const handleCopyToClipboard = (text) => {
    toast("Copied Url", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const count = useRef(1);
  const columns = React.useMemo(
    () => [
      {
        Header: <span>#</span>,
        accessor: "id",
        Cell: ({row}) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Account",
        accessor: "account",
        Cell: ({row}) => (
          <span
            style={{fontSize: "12px", cursor: "pointer"}}
            onClick={() => {
              dispatch(
                setActiveAccount({
                  login_id: row?.original?.account?.replace("%23", "#"),
                  trading_platform: row?.original?.trading_platform,
                  email: row?.original?.email,
                }),
              );

              setTimeout(() => {
                navigate(`/account-metrics/program-objectives`);
              }, 200);
            }}
          >
            {row.original.account}
          </span>
        ),
      },
      {
        Header: "Funded Account",
        accessor: "funded_account",
        Cell: ({row}) => (
          <>
            {row.original.funded_account ? (
              <span
                style={{fontSize: "12px", cursor: "pointer"}}
                onClick={() => {
                  dispatch(
                    setActiveAccount({
                      login_id: row?.original?.funded_account?.replace("%23", "#"),
                      trading_platform: row?.original?.trading_platform,
                      email: row?.original?.email,
                    }),
                  );

                  setTimeout(() => {
                    navigate(`/account-metrics/program-objectives`);
                  }, 200);
                }}
              >
                {row.original.funded_account}
              </span>
            ) : (
              "-"
            )}
          </>
        ),
      },
      {
        Header: "Verified",
        accessor: "is_verified",
        Cell: ({row}) => (
          <>
            {row.original.is_verified ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="17"
                  height="17"
                  rx="8.5"
                  stroke="#39BE43"
                />
                <path
                  d="M6 10.0769L7.76471 12L12 7"
                  stroke="#39BE43"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <>
                {" "}
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.05273 9.00033C1.05273 6.8925 1.89007 4.871 3.38053 3.38053C4.871 1.89007 6.8925 1.05273 9.00033 1.05273C11.1082 1.05273 13.1297 1.89007 14.6201 3.38053C16.1106 4.871 16.9479 6.8925 16.9479 9.00033C16.9479 11.1082 16.1106 13.1297 14.6201 14.6201C13.1297 16.1106 11.1082 16.9479 9.00033 16.9479C6.8925 16.9479 4.871 16.1106 3.38053 14.6201C1.89007 13.1297 1.05273 11.1082 1.05273 9.00033ZM9.00033 2.19273C7.19485 2.19273 5.46331 2.90996 4.18663 4.18663C2.90996 5.46331 2.19273 7.19485 2.19273 9.00033C2.19273 10.8058 2.90996 12.5374 4.18663 13.814C5.46331 15.0907 7.19485 15.8079 9.00033 15.8079C10.8058 15.8079 12.5374 15.0907 13.814 13.814C15.0907 12.5374 15.8079 10.8058 15.8079 9.00033C15.8079 7.19485 15.0907 5.46331 13.814 4.18663C12.5374 2.90996 10.8058 2.19273 9.00033 2.19273ZM11.8251 6.17673C11.9376 6.28925 12.0008 6.44184 12.0008 6.60093C12.0008 6.76003 11.9376 6.91262 11.8251 7.02514L9.84873 9.00033L11.8251 10.9755C11.9378 11.0882 12.0011 11.241 12.0011 11.4003C12.0011 11.5597 11.9378 11.7125 11.8251 11.8251C11.7125 11.9378 11.5597 12.0011 11.4003 12.0011C11.241 12.0011 11.0882 11.9378 10.9755 11.8251L9.00033 9.84873L7.02514 11.8251C6.96935 11.8809 6.90312 11.9252 6.83024 11.9554C6.75735 11.9856 6.67923 12.0011 6.60034 12.0011C6.52144 12.0011 6.44332 11.9856 6.37043 11.9554C6.29755 11.9252 6.23132 11.8809 6.17553 11.8251C6.11975 11.7694 6.0755 11.7031 6.04531 11.6302C6.01512 11.5573 5.99958 11.4792 5.99958 11.4003C5.99958 11.3214 6.01512 11.2433 6.04531 11.1704C6.0755 11.0975 6.11975 11.0313 6.17553 10.9755L8.15194 9.00033L6.17553 7.02514C6.06287 6.91247 5.99958 6.75967 5.99958 6.60034C5.99958 6.441 6.06287 6.2882 6.17553 6.17553C6.2882 6.06287 6.441 5.99958 6.60034 5.99958C6.75967 5.99958 6.91247 6.06287 7.02514 6.17553L9.00033 8.15194L10.9755 6.17553C11.0313 6.11966 11.0975 6.07533 11.1704 6.04508C11.2433 6.01483 11.3214 5.99926 11.4003 5.99926C11.4793 5.99926 11.5574 6.01483 11.6303 6.04508C11.7032 6.07533 11.7694 6.12086 11.8251 6.17673Z"
                      fill="#F26F6F"
                    />
                  </svg>
                </>
              </>
            )}
          </>
        ),
      },
      {
        Header: "Account Type",
        accessor: "account_type",
        Cell: ({row}) => <>{row.original.account_type?.replace(/Challenge/gi, "")?.replace(/_/g, "-")?.trim()}</>,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({row}) => (
          <div
            className="status_wrapper"
            style={{display: "flex", flexDirection: "column"}}
          >
            <span
              className={`${
                row.original.status === "in_progress" || row.original.status === "warning"
                  ? "status status-progress"
                  : row.original.status === "failed"
                  ? "status-error status"
                  : row.original.status === "approved"
                  ? "status-passes status"
                  : row.original.status === "new"
                  ? "status-new status"
                  : "status"
              }`}
            >
              {row.original.status?.replace("_", " ")}
            </span>
          </div>
        ),
      },
      // {
      //   Header: "URL",
      //   accessor: "url",
      //   Cell: ({row}) => (
      //     <>
      //       <ToastContainer />
      //       {row.original.url && (
      //         <div
      //           className="column_one"
      //           style={{
      //             display: "flex",
      //             alignItems: "center",
      //             width: "200px",
      //             justifyContent: "space-between",
      //           }}
      //         >
      //           <p> {truncateString(row.original.url, 20)}</p>
      //           <CopyToClipboard
      //             onCopy={handleCopyToClipboard}
      //             text={row.original.url}
      //           >
      //             <p
      //               className="table_copy_button"
      //               style={{
      //                 marginRight: "20px",
      //                 cursor: "pointer",
      //               }}
      //             >
      //               <svg
      //                 width="28"
      //                 height="28"
      //                 viewBox="0 0 24 24"
      //                 fill="none"
      //                 xmlns="http://www.w3.org/2000/svg"
      //               >
      //                 <rect
      //                   width="24"
      //                   height="24"
      //                   rx="12"
      //                   fill="#071E0D"
      //                 />
      //                 <path
      //                   d="M17.886 12.574C18 12.2987 18 11.9487 18 11.25C18 10.5513 18 10.2013 17.886 9.926C17.8106 9.74395 17.7001 9.57854 17.5608 9.43922C17.4215 9.29989 17.256 9.18938 17.074 9.114C16.7987 9 16.4487 9 15.75 9H11.4C10.56 9 10.14 9 9.81933 9.16333C9.53684 9.30719 9.30719 9.53684 9.16333 9.81933C9 10.1393 9 10.5593 9 11.4V15.75C9 16.4487 9 16.7987 9.114 17.074C9.26667 17.4413 9.55867 17.734 9.926 17.886C10.2013 18 10.5513 18 11.25 18C11.9487 18 12.2987 18 12.574 17.886M17.886 12.574C17.8106 12.756 17.7001 12.9215 17.5608 13.0608C17.4215 13.2001 17.256 13.3106 17.074 13.386C16.7987 13.5 16.4487 13.5 15.75 13.5C15.0513 13.5 14.7013 13.5 14.426 13.614C14.244 13.6894 14.0785 13.7999 13.9392 13.9392C13.7999 14.0785 13.6894 14.244 13.614 14.426C13.5 14.7013 13.5 15.0513 13.5 15.75C13.5 16.4487 13.5 16.7987 13.386 17.074C13.3106 17.256 13.2001 17.4215 13.0608 17.5608C12.9215 17.7001 12.756 17.8106 12.574 17.886M17.886 12.574C17.5275 13.8107 16.8678 14.9391 15.9661 15.8582C15.0645 16.7774 13.9489 17.4585 12.7193 17.8407L12.574 17.886M15 9V8.4C15 7.56 15 7.14 14.8367 6.81933C14.693 6.53694 14.4636 6.3073 14.1813 6.16333C13.86 6 13.44 6 12.6 6H8.4C7.56 6 7.14 6 6.81933 6.16333C6.53684 6.30719 6.30719 6.53684 6.16333 6.81933C6 7.13933 6 7.55933 6 8.4V12.6C6 13.44 6 13.86 6.16333 14.1807C6.30733 14.4633 6.53667 14.6927 6.81933 14.8367C7.13933 15 7.56 15 8.40067 15H9"
      //                   stroke="#36D66B"
      //                   stroke-linecap="round"
      //                   stroke-linejoin="round"
      //                 />
      //               </svg>
      //             </p>
      //             {/* </button> */}
      //           </CopyToClipboard>
      //         </div>
      //       )}
      //     </>
      //   ),
      // },
      {
        Header: "Contract Issued",
        accessor: "contract_issued",
        Cell: ({row}) => <>{row.original.contract_issued ? "Yes" : "No"}</>,
      },
      {
        Header: "Created on",
        accessor: "created_at",
        Cell: ({row}) => <>{moment(row.original.created_at).format("DD-MMM-YYYY")}</>,
      },

      {
        Header: "Action",
        accessor: "action",
        Cell: ({row}) => {
          const [payload, setPayload] = useState({
            contract_id: row.original.id,
            account: row.original.account,
            is_tnc_accepted: false,
          });
          const [loading, setLoading] = useState(false);
          const [isModalOpen, setIsModalOpen] = useState(false);
          const dispatch = useDispatch();

          const handleSignContract = async () => {
            setLoading(true);
            try {
              const response = await digiSigner(idToken, payload?.contract_id);
              console.log("response?", response?.response?.data?.detail === "Please submit your KYC first and then try again.");

              if (response?.response?.data?.detail === "Please submit your KYC first and then try again.") {
                const customBtn = "verification-kyc/*";
                dispatch(returnErrors(response?.response?.data?.detail, response?.response?.status, "", customBtn));
                return;
              }

              console.log(response, "response");
              if (response?.status < 399) {
                window.location.replace(response?.data?.url);

                if (response?.data?.is_completed === true) {
                  dispatch(returnMessages("Contract signed successfully", response.status));
                  fetchContactList();
                  dispatch(getAccountList({idToken, selectedBrand}));
                } else {
                  dispatch(returnErrors(response.data.detail, response.status));
                }
              } else {
                dispatch(returnErrors(response.response.data.detail, response.response.status));
              }
            } catch (error) {
              dispatch(returnErrors("Something went wrong", 500));
            } finally {
              setLoading(false);
              setIsModalOpen(false);
            }
          };

          const handleOpenModal = () => {
            setIsModalOpen(true);
          };

          const handleCloseModal = () => {
            setIsModalOpen(false);
            setPayload({...payload, is_tnc_accepted: false});
          };

          const handleConfirm = () => {
            handleSignContract();
          };

          return (
            <div className="contractActionBox">
              {row.original.is_verified ? (
                <p className="contractStatus">Contract already signed</p>
              ) : (
                <>
                  <button
                    className="contractActionBtn"
                    onClick={handleConfirm}
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Sign Contract"}
                  </button>
                  {/* <ConfirmationModal
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onConfirm={handleConfirm}
                    payload={payload}
                    setPayload={setPayload}
                    link={row.original.account_type === "2_step" ? `/contract-agreement-two/${row?.original?.challenge_name}` : `/contract-agreement-one/${row?.original?.challenge_name}`}
                    title="Confirm Contract Signing"
                    message="Please review and accept the terms and conditions to proceed with signing the contract."
                    confirmText="Sign Contract"
                    cancelText="Cancel"
                  /> */}
                </>
              )}
            </div>
          );
        },
      },
    ],
    [],
  );

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <>
      {isLoading && <LoaderOverlay />}
      <div className="contract_list">
        <ReactTable
          data={contactList}
          columns={columns}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </>
  );
};
